import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Modal,Table,loadURLSVGs } from '@dds-uicore/all';
import { EventEmitter } from '@angular/core';
import { FileElement } from 'src/app/model/file-element';
import { FileCatalystAPIService } from 'src/app/services/file-catalyst-api.service';
import { FileExplorerService } from 'src/app/services/file-explorer.service';
import { Observable } from 'rxjs';
import { FileObjectsModel, FileObjectList } from 'src/app/model/file-objects-model';
import { FileExplorerOut } from 'src/app/model/file-explorer-out';

@Component({
  selector: 'app-file-explorer',
  templateUrl: './file-explorer.component.html',
  styleUrls: ['./file-explorer.component.css']
})

export class FileExplorerComponent implements OnInit, AfterViewInit,OnDestroy {
  @ViewChild('triggerContainer') triggerContainer: ElementRef<HTMLElement>;
  @Input() modalId: string;
  @Input() modalTitleId: string;
  @Input() index:number;
  @Input() fileExtensions: string[];
  @Input() fileExtensionString:string;
  @Input() fileTypeCode:string;
  @Output() fileNamePath = new EventEmitter();

  data_test = []
  selectedIndex: number = null;

  fcElement:FileObjectsModel;
  private fileObjectList:FileObjectList[];
  fileElements: Observable<FileElement[]>;
  selectedElement:FileElement;
  removeElements:string[] = new Array<string>();
  path_files = '';
  folderName:string="";
  currentRoot: FileElement;
  currentPath: string;
  canNavigateUp = false;
  searchEnabled:boolean = false;
  textEnabled:boolean = false;
  newPath:string;
  fileElement_c:FileElement;
  fileElementsData:FileElement[] = [];
  fileExtension : string = '.ext, .all, .pdf';
  modalEle:any;
  invalidFileExt: boolean;
  currFileExt: string;
  public selectedRow : any
  errorLoadingMsg: string=""
  error:boolean=false
  constructor(private httpclient: HttpClient, private fileService:FileExplorerService,
    private fileCatalystService:FileCatalystAPIService,) {

   
   }
  ngOnDestroy(): void {
    // throw new Error('Method not implemented.');
    this.fileService.clearMap();
  }
  ngAfterViewInit(): void {
    // this.fileExtension = this.fileExtensions.toString();
    // console.log('File Extension ',this.fileExtension)
    const content = this.triggerContainer.nativeElement;
    if (content) {
      const actualContent = (content.children) ? content.children[0] : content;
      // This two attributes are needed by @dds-uicore Modal
      actualContent.setAttribute('data-toggle', 'dds__modal');
      actualContent.setAttribute('data-target', `#${this.modalId}`);
      this.modalEle = new Modal(actualContent);
    }

    
  }

  ngOnInit(): void {
    this.fileExtension = this.fileExtensions.toString();
    console.log('File Extension ',this.fileExtension);
    console.log('File Elements data ',this.fileElementsData)
    
      // this.fileElementsData = [];
      this.initializeFCRootDir();
   
    
    this.data_test = [
      {
        'fileName' : 'agile aic flow.vsdx',
        'dateModified' : '4/7/2021, 6:04:00PM',
        'size' : '60900 KB',
        'isFile' : true,
        'isActive' : false
      },
      {
        'fileName' : 'Agile File acceleration POC.vsd',
        'dateModified' : '3/29/2021, 3:27:00PM',
        'size' : '215522 KB',
        'isFile' : false,
        'isActive' : false
      },
      {
        'fileName' : 'Agile File attachment utility.pdf',
        'dateModified' : '3/25/2021, 3:19:13 AM',
        'size' : '1053286 KB',
        'isFile' : true,
        'isActive' : false
      },
      {
        'fileName' : 'agile aic flow.vsdxx',
        'dateModified' : '4/7/2021, 6:04:00PM',
        'size' : '60900 KB',
        'isFile' : true,
        'isActive' : false
      },
      {
        'fileName' : 'Agile File acceleration POC.vsdd',
        'dateModified' : '3/29/2021, 3:27:00PM',
        'size' : '215522 KB',
        'isFile' : false,
        'isActive' : false
      },
      {
        'fileName' : 'Agile File attachment utility.pdff',
        'dateModified' : '3/25/2021, 3:19:13 AM',
        'size' : '1053286 KB',
        'isFile' : true,
        'isActive' : false
      }]
    loadURLSVGs([
      "https://uicore.dellcdn.com/1.3.3/svgs/dds__folder.svg",
      "https://uicore.dellcdn.com/1.3.3/svgs/dds__search.svg",
      "https://uicore.dellcdn.com/1.3.3/svgs/dds__document.svg",

      ], true); 

    this.modalId = `${this.modalId}-modal-${this.Uuid()}`;
    this.modalTitleId = `${this.modalTitleId}-modal-${this.Uuid()}`; 

    console.log('In File Explorer Component')
    // this.getData()
    // .then((data) => this.createOptions(data))
    // .then((options) => { 

    //   // then and initilize DDS Table element 
    //   const tableElement = document.querySelectorAll("[data-table=\"dds__table\"]");
    //   new Table(tableElement[0], options);
    // });
  }
  enableSearch(){
    console.log('In enable Search Method ')
    this.textEnabled=!this.textEnabled;
    this.searchEnabled=!this.searchEnabled;
  }

  disableSearch(){
    this.textEnabled=false;
    this.searchEnabled=false;
  }

  querySearch(){
    this.error=false;
    this.errorLoadingMsg="";
    console.log('In query search method ',this.newPath);
    if(this.newPath != undefined){
      // this.newPath = this.newPath.split('\\').join('/');
      this.fileCatalystService.queryFCLocal(this.newPath).subscribe(
        fcData => {
          this.currentRoot=this.fileElement_c;
          var tempFcEle:FileElement;
          for(var fcObj of fcData.fileObjectList.slice(1)){
            tempFcEle = this.fileService.add({
              name:fcObj.name,
              isFile:fcObj.isFile,
              parent:this.fileElement_c.id,
              path:fcObj.path,
              directory:fcData.directory,
              lastModifiedDate:(new Date(fcObj.lastModified)).toLocaleString(),
              size:this.numberWithCommas(fcObj.size)
            });
            this.removeElements.push(tempFcEle.id);
          }
          this.fileService.setCurrentPath(fcData.directory);
          this.updateFileElementQuery();
         //this.currentPath = fcData.directory;
          this.canNavigateUp = true;
        },
        (error)=>
        {
          console.log('error from file catalyst service  ',error);
          this.error=true;
          this.errorLoadingMsg = 'Invalid Directory, Path not found...'
        }
      )
    }
  }
  // openMenu(event: MouseEvent) {
  //   event.preventDefault();
  //   // viewChild.openMenu();
  // }

  // navigate(element: FileElement) {
  //   console.log('in Navigate method ',element)
  //   if (!element.isFile) {
  //     this.navigateToFolder(element);
  //   }
  // }

  navigateUpCurrentPath(){
    this.error=false;
    this.errorLoadingMsg="";
    console.log('In Navigate UP Current method ',this.currentPath);
    if(this.currentPath != undefined){
      // this.currentPath = this.currentPath.split('\\').join('/');
      this.fileCatalystService.queryFCLocal(this.currentPath).subscribe(
        fcData => {
          this.currentRoot=this.fileElement_c;
          var tempFcEle:FileElement;
          for(var fcObj of fcData.fileObjectList.slice(1)){
            tempFcEle = this.fileService.add({
              name:fcObj.name,
              isFile:fcObj.isFile,
              parent:this.fileElement_c.id,
              path:fcObj.path,
              directory:fcData.directory,
              lastModifiedDate:(new Date(fcObj.lastModified)).toLocaleString(),
              size:this.numberWithCommas(fcObj.size)
            });
            this.removeElements.push(tempFcEle.id);
          }
          this.fileService.setCurrentPath(fcData.directory);
          this.updateFileElementQuery();
         //this.currentPath = fcData.directory;
          this.canNavigateUp = true;
        },
        (error)=>
        {
          console.log('error from file catalyst service  ',error);
          this.error=true;
          this.errorLoadingMsg = 'Something went wrong, please try again...'
        }
      )
    }
  }

  navigateToFolder(element:FileElement,index){
    if(element.isFile){
      console.log('selected item ',this.selectedElement)
      this.selectedIndex = index;
      element.isActive = !element.isActive
      this.selectedElement = element;
      // this.emit(this.selectedElement)
      // if(this.selectedElement !=undefined){
      //   // document.getElementById(this.selectedElement.name).style.color = "black"
      //   // document.getElementById(element.name).style.color = "blue";
      //   this.selectedElement = element;
      // }else{
      //   // document.getElementById(element.name).style.color = "blue";
      //   this.selectedElement = element;
      // }
    }else{
      this.selectedElement = undefined;
      console.log('In navigate to folder method ',element);
      this.currentRoot = element;
      this.queryLocalDirectory(element);
    }
  }

  navigateUp(){

    this.selectedElement = undefined;
    console.log('in Navigate up method. remove elements ',this.removeElements)
    this.fileService.deleteElements(this.removeElements);
    this.removeElements = new Array<string>();
    console.log('map size ',this.fileService.getElementsSize())
    this.currentRoot=this.fileService.getCurrentRoot();
    if (this.currentRoot && this.currentRoot.parent === 'root') {
      console.log('Navigate up method. current root ',this.currentRoot,' parent ',this.currentRoot.parent)
      this.currentRoot = null;
      this.canNavigateUp = false;
      //this.updateFileElementQuery();
    } else {
      console.log('Navigate up method.. ',this.currentRoot);
      this.currentRoot = this.fileService.get(this.currentRoot.parent);
      //this.updateFileElementQuery();
    }
    this.currentPath = this.popFromPath(this.currentPath);
    this.navigateUpCurrentPath();
    if(this.currentPath.length == 0)
    {
      this.currentPath=this.path_files;
      this.initializeFCRootDir();
    }
    //this.fileService.setCurrentPath(this.popFromPath(this.currentPath));
    //this.updateFileElementQuery();
    
  }

  popFromPath(path: string) {
    let p = path ? path : '';
    console.log('path ',path)
    let split = p.split('/');
    split.splice(-1, 1);
    p = split.join('/');
    console.log('path at pop from path ',p)
    return p;
  }
  initializeFCRootDir()
  {
    // console.log('this.fileExtensions string ',this.fileExtensions.toString())
    // this.fileExtension = this.fileExtensions.toString();
    // console.log('File Extension ',this.fileExtension)
    this.error=false;
    this.errorLoadingMsg="";
    this.fileCatalystService.queryFCLocal("").subscribe(
      fcData => 
      {
        if(this.fileService.getElementsSize()!=0){
          this.clearMap();
        }
        console.log('fc Data ',fcData)
        if(fcData != undefined){
          console.log('fc Data length ',fcData.fileObjectList.length)
          for(var fcObj of fcData.fileObjectList){
            this.fileElement_c =this.fileService.add({
              name:fcObj.name.replace(':\\',''),
              isFile:fcObj.isFile,
              parent:'root',
              path:fcObj.path,
              directory:this.path_files,
              lastModifiedDate:(new Date(fcObj.lastModified)).toLocaleString(),
              size:this.numberWithCommas(fcObj.size)
            });
            this.currentPath=this.path_files;
            this.fileService.setCurrentPath(this.currentPath);
          }
		  this.currentRoot=undefined;
          this.updateFileElementQuery();
        }  
      },
      (error)=>
      {
        console.log('error from file catalyst service  ',error);
        this.error=true;
        this.errorLoadingMsg = 'Something went wrong, please try again...'
      }
    )
  }
  queryLocalDirectory(element:FileElement)
  {
    this.error=false;
    this.errorLoadingMsg="";
    this.fileCatalystService.queryFCLocal(element.path).subscribe(
      fcData =>{
        for(var fcObj of fcData.fileObjectList.slice(1)){
          this.fileService.add(
            {
              name:fcObj.name,
              isFile:fcObj.isFile,
              parent:element.id,
              path:fcObj.path,
              directory:fcData.directory,
              lastModifiedDate:(new Date(fcObj.lastModified)).toLocaleString(),
              size:this.numberWithCommas(fcObj.size)
            }
          )
        }
        //this.currentPath = fcData.directory;
        this.fileService.setCurrentPath(fcData.directory);
        this.updateFileElementQuery();
        this.canNavigateUp = true;
      },
      (error)=>
      {
        console.log('error from file catalyst service  ',error);
        this.error=true;
        this.errorLoadingMsg = 'Something went wrong, please try again...'
      }
    )
  }
  updateFileElementQuery(){
    console.log('current root ',this.currentRoot);
    this.fileService.setCurrentRoot(this.currentRoot);
    this.fileService.queryInFolder(this.currentRoot ? this.currentRoot.id : 'root')
     .subscribe(
      data => 
      {
        // this.dataSource.data = data;
        this.fileElementsData = data;
        this.currentPath=this.fileService.getCurrentPath();
        this.newPath=this.currentPath;
        this.newPath.replace('/','\\');
        //console.log("Update File Element ",this.currentPath);
      });
  }
  numberWithCommas(x:number){
    if(x > 0){
      var y = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",").concat(' Bytes');;
      return y;
      }else{
        return '';
      }
  }
  // async getData(): Promise<any> {
  //   const data=<any> await this.httpclient
  //   .get('https://quickbyte-api.r1.pcf.dell.com/publish_article/')
  //   .toPromise();
  //   // const data = []
  //   console.log(data)
  //     return data;
  // }

  Uuid() {
    const windowObj: any = window;
    const winCrypto = windowObj.crypto || windowObj.msCrypto;
    let index = winCrypto.getRandomValues(new Uint32Array(1))[0];
    index = +`${index}`.substr(0, 1);
    const uuid = winCrypto.getRandomValues(new Uint32Array(10))[index];
    return uuid;
  }

 

  emit(fileElement : FileElement){
    // console.log('sending '+fileNamePath+"::"+this.index)
    const content = this.triggerContainer.nativeElement;
    console.log("Content ",content);
    this.invalidFileExt=false;
    if(fileElement != null){
    let fileElementOut:FileExplorerOut = new FileExplorerOut();
    fileElementOut.fileElement = fileElement;
    fileElementOut.index = this.index;
    console.log("File Extensions ",this.fileExtensions);
    console.log("File Element Name ",fileElement.name.split(".")[1]);
    let fileName=fileElement.name.toLowerCase().substring(fileElement.name.lastIndexOf("."));
    this.currFileExt=fileName;
    console.log('Current File Extension ',this.currFileExt)
    console.log('this.fileExtensions ',this.fileExtensions)
    console.log('this.fileExtensions.includes(this.currFileExt) ',this.fileExtensions.includes(this.currFileExt))
    if(this.fileExtensions.includes(this.currFileExt) || this.fileExtensions.includes(".all"||".ALL"||"all"||"ALL")){
      console.log('Emitting ',fileElement)
      // if (content) {
      //   const actualContent = (content.children) ? content.children[0] : content;
      //   // This two attributes are needed by @dds-uicore Modal
      //   actualContent.setAttribute('data-toggle', 'dds__modal');
      //   actualContent.setAttribute('data-target', `#${this.modalId}`);
      //   new Modal(actualContent);
      //   this.modalEle = new Modal(actualContent);
      //   console.log("Model Element ",this.modalEle);
      // }
      this.fileNamePath.emit(fileElementOut)
      console.log('closing the modal')
      this.modalEle.hide();
      console.log('closed the modal')
    }
    else{
      console.log("False");
      this.invalidFileExt=true;
      //document.getElementById("fileTypeMsg").style.backgroundColor="pink";

    }

  }
  }

  // public highlightRow(dataitem){
  //   this.selectedRow = dataitem.fileName
  //   console.log(this.selectedRow)
  // }
  setIndex(index: number, dataitem : any) {
      this.selectedIndex = index;
      dataitem.isActive = !dataitem.isActive
      if(dataitem.isActive == false){
        this.emit(null)
      }
      else
        this.emit(dataitem.fileName)    
 }

 clearMap()
 {
  this.fileService.clearMap();
 }
 onConfirm(){
   console.log('On Confirm ')
    if(this.selectedElement != undefined)
    {
      this.emit(this.selectedElement);
    }
 }

 changeExtErr(){
   if(this.invalidFileExt){
     this.invalidFileExt=false;
   }
   if(this.error){
     this.error=false;
     this.errorLoadingMsg="";
     this.newPath='';
   }
 }
 browse(){
   console.log('In File Explorer Browse ');
   console.log('File elements data ',this.fileElementsData)
   if(this.fileElementsData != undefined && this.fileElementsData.length == 0){
    console.log('File elements data length ',this.fileElementsData.length)
    this.initializeFCRootDir();
   }
 }
}
